/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export * from "./IAssetsManager";
export * from "./IResource";
export * from "./IResourceAdapter";
export * from "./IResourceType";
export * from "./IResourceLock";
export * from "./IResourceManager";
export * from "./IManifest";
export * from "./IThemeManager";
export * from "./resourceTypes";
export * from "./Resource";
export * from "./ResourceManager";
export * from "./ResourceErrorNames";
